"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _marginMixin = require("../marginMixin");
var _spaceMixin = require("../spaceMixin");
var _statusDialogMixin = require("../statusDialogMixin");
/** @class AlertMixin */
/** @method */
var AlertMixin = function AlertMixin(props) {
  return (0, _styledToken.default)({
    borderRadius: 'Alert.borderRadius',
    toastActionFlex: 'Alert.Toast.Action.flex',
    toastActionIconSize: 'Alert.Toast.Action.iconSize',
    toastActionMarginLeft: 'Alert.Toast.Action.marginLeft',
    toastActionMarginTop: 'Alert.Toast.Action.marginTop',
    toastActionOrder: 'Alert.Toast.Action.order',
    toastBodyFlex: 'Alert.Toast.Body.flex'
  }, function (_ref) {
    var _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$toastActionFlex = _ref.toastActionFlex,
      toastActionFlex = _ref$toastActionFlex === void 0 ? '1 1 100%' : _ref$toastActionFlex,
      toastActionIconSize = _ref.toastActionIconSize,
      toastActionMarginLeft = _ref.toastActionMarginLeft,
      toastActionMarginTop = _ref.toastActionMarginTop,
      _ref$toastActionOrder = _ref.toastActionOrder,
      toastActionOrder = _ref$toastActionOrder === void 0 ? 2 : _ref$toastActionOrder,
      _ref$toastBodyFlex = _ref.toastBodyFlex,
      toastBodyFlex = _ref$toastBodyFlex === void 0 ? '1 1 0' : _ref$toastBodyFlex;
    return (0, _styledComponents.css)(["", " border-radius:", "px;", "{flex:", ";}flex-flow:row wrap;", "{margin-left:", "px;margin-top:", ";order:", ";flex:", ";}", ""], (0, _statusDialogMixin.statusDialogMixin)(props), borderRadius, _drywall.Toast.Body, toastBodyFlex, _drywall.Toast.Action, (0, _spaceMixin.spaceMixin)(toastActionMarginLeft, function (space) {
      return space.value + toastActionIconSize;
    })(props), toastActionMarginTop ? toastActionMarginTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), toastActionOrder, toastActionFlex, (0, _marginMixin.marginMixin)(props));
  })(props);
};
exports.AlertMixin = AlertMixin;